import React, { useState, useEffect } from "react";
import styled from "styled-components";
import oh from "output-helpers";
import withConfig from "with-config";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Location } from "history";
import FormCard from "../components/FormCard";

import backgroundImage from "../img/background.svg";
import SSO from "sso-helper";
import ResetPasswordForm from "../components/PasswordResetForm";

interface ResetPasswordViewProps {
  location: Location;
}

const Container = styled.div`
  background-color: #f6f6f6;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${backgroundImage});
  background-position: center 0;
  background-repeat: no-repeat;
  .msg {
    padding: 20px 42px 30px;
    text-align: center;
    p {
      font-size: 14px;
      font-weight: 700;
    }
    a {
      display: inline-block;
      font-size: 14px;
      padding: 12px;
      opacity: 0.7;
      width: 100%;
      font-weight: 500;
      &:hover {
        opacity: 1;
      }
    }
  }
`;

const ResetPasswordView = ({ location }: ResetPasswordViewProps) => {
  let [processing, setProcessing] = useState(false);
  let [error_message, setErrorMessage] = useState("");
  let [done, setDone] = useState(false);

  const query = new URLSearchParams(location.search);
  const username = query.get("username");
  const code = query.get("code");

  useEffect(() => {
    const config = withConfig.getCurrentConfig();

    if (!window.sso) {
      window.sso = new SSO("dashboard", {
        token_provider_uri: config.api.sso.api_uri
      });
    }
  }, []);

  return (
    <Container>
      <FormCard title={oh.translate("reset_password")} subtitle="">
        {done ? (
          <div className={"msg"}>
            <p>{oh.translate("password_reset_completed")}</p>
            <Link to="/">{oh.translate("return_to_login")}</Link>
          </div>
        ) : (
          <ResetPasswordForm
            disabled={processing}
            error_message={error_message}
            onCloseErrorMessage={() => setErrorMessage("")}
            onSubmit={({ password, password_confirm }) => {
              setProcessing(true);
              if (password === password_confirm && password.length > 0) {
                window.sso
                  .performPasswordReset(username, password, code)
                  .then(() => {
                    setDone(true);
                  })
                  .catch((err: any) => {
                    if (
                      err.response &&
                      err.response.status >= 400 &&
                      err.response.status < 500
                    ) {
                      setErrorMessage(
                        oh.translate("error_unable_to_update_password")
                      );
                    } else {
                      setErrorMessage(oh.translate("error_general"));
                    }
                  })
                  .finally(() => {
                    setProcessing(false);
                  });
              } else {
                setErrorMessage(oh.translate("reset_password_match_error"));
                setProcessing(false);
              }
            }}
          />
        )}
      </FormCard>
    </Container>
  );
};

export default withRouter(ResetPasswordView);



// WEBPACK FOOTER //
// ./src/views/ResetPassword.tsx